import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureDataExplorerCopySink } from 'app/model/pipeline/copysink/azure-data-explorer.copysink';
import { CopySinkAdapter } from './copysink.adapter';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataExplorerCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        ingestionMappingName: '*',
        structure: '*',
        additionalProperties: '*'
    }
})
export class AzureDataExplorerSinkAdapter extends CopySinkAdapter<
    AzureDataExplorerCopySink,
    Model.AzureDataExplorerSink
> {
    protected model(): IModel {
        return AzureDataExplorerCopySink.MODEL;
    }

    protected override async _toResource(model: AzureDataExplorerCopySink): Promise<Model.AzureDataExplorerSink> {
        const result: Model.AzureDataExplorerSink = {
            type: this.model().name
        };
        result.ingestionMappingName = ValueAdapter.toResource(model, AzureDataExplorerCopySink.INGESTION_MAPPINGNAME);
        result.additionalProperties = ValueAdapter.toResource(model, AzureDataExplorerCopySink.ADDITIONAL_PROPERTIES);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.AzureDataExplorerSink,
        owner: Activity
    ): Promise<AzureDataExplorerCopySink> {
        const result = Owned.create<AzureDataExplorerCopySink>(this.model(), owner);

        if (resource.ingestionMappingName != null) {
            ValueAdapter.toModel(
                result,
                AzureDataExplorerCopySink.INGESTION_MAPPINGNAME,
                resource.ingestionMappingName
            );
        }
        if (resource.additionalProperties != null) {
            ValueAdapter.toModel(
                result,
                AzureDataExplorerCopySink.ADDITIONAL_PROPERTIES,
                resource.additionalProperties
            );
        }
        CopySinkAdapter.toCommonCopySinkModel(result, resource);

        return result;
    }
}
